// extracted by mini-css-extract-plugin
export var aircallIframe = "_ds-3";
export var fabContainer = "_ds-5";
export var fabRinging = "_ds-6";
export var loadingOverlay = "_ds-4";
export var pulse = "_ds-7";
export var widgetContent = "_ds-2";
export var widgetPanel = "_ds-0";
export var widgetPanelExpanded = "_ds-1";